
import { grey } from '@material-ui/core/colors';

export default () => ({
  gridItem: {
    zIndex: 0,
    minWidth: 300,
  },
  greyColor: { color: grey[600] },
  footerIcon: {
    color: grey[600],
    marginRight: 5,
    paddingTop: 5,
  },
  footerCreate: {
    color: '#0091EB',
    marginTop: 4,
  },
  footerComplete: {
    color: '#99BCDC',
    marginTop: 4,
    marginLeft: 10,
  },
  footerComment: {
    color: '#005081',
    marginTop: 4,
    marginLeft: 10,
  },
  footerStatusChange: {
    color: '#EAC494',
    marginTop: 4,
    marginLeft: 10,
  },
  paginationText: {
    color: grey[600],
    marginRight: 5,
  },
  paginationIcon: {
    color: grey[600],
    padding: 0,
  },
});
